import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import ProgressBar from "react-bootstrap/ProgressBar";
import { connect } from "react-redux";
import {
  cancelPackage,
  getMyReports,
  getReport,
} from "../../../../store/actions/userActions";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Report from "../../../../Pages/Report";
import ReactFullScreenElement from "react-fullscreen-element";
import Loading from "../../../common/Loading";
import FeedbackModal from "./FeedbackModal";
import GiversFeedback from "./GiversFeedback";
import { VisitingUser } from "../../../../store/actions/siteActions";

class MyReports extends Component {
  state = {
    score: 0,
    error: "",
    loading: true,
    showReport: false,
    givingFB: false,
    viewingFB: false,
    sesId: "",
    serviceName: "",
    services: [],
  };
  componentDidMount() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let source = params.get("utm_source");
    let campaign = params.get("utm_camp");
    let manager = params.get("utm_mr");
    localStorage.setItem("src", source);
    localStorage.setItem("cmp", campaign);
    localStorage.setItem("mr", manager);
    if (source != null || campaign != null || manager != null) {
      this.props.VisitingUser({ source, campaign, manager });
    }
    this.props
      .getReport()
      .then((data) => {
        const { score } = data;
        this.setState({ score });
      })
      .catch((e) => this.setState({ error: e.message }));
    this.getMyReports();
  }
  getMyReports = () => {
    this.props
      .getMyReports()
      .then(({ coaching, therapy, freelance, digital }) => {
        this.setState({
          services: [...coaching, ...freelance, ...therapy, ...digital],
          loading: false,
        });
      })
      .catch((e) => alert(e.message));
  };
  handleFB = (sesId, serviceName) => {
    this.setState({ sesId, serviceName }, () =>
      this.setState({ givingFB: true })
    );
  };
  handleGFB = (sesId, serviceName) => {
    this.setState({ sesId, serviceName }, () =>
      this.setState({ viewingFB: true })
    );
  };
  render() {
    if (this.props.seekerstatus < 0)
      return <p>This user is been deactivated!</p>;
    if (this.state.loading) return <Loading />;
    return (
      <div className="container myreports pb--60">
        <h3>My Feedbacks</h3>
        {this.state.services.length > 0 ?
          <Row className="p-0 m-0">
            {this.state.services.length > 0 && (
              <p className="mt--20">Courses and Workshops</p>
            )}
            <Col sm={12}>
              {this.state.services.length
                ? this.state.services.map(
                  (
                    {
                      id,
                      sessionsdone,
                      totalsessions,
                      service,
                      packagename,
                      type,
                      sessions,
                      activatecancel,
                      status,
                    },
                    i
                  ) => {
                    const pert = (sessionsdone / totalsessions) * 100;
                    return (
                      <div className="container sessions" key={i}>
                        <Card>
                          <Row className="justify-content-between mb--10">
                            <Col sm={6}>
                              <div className="text-left">
                                <p className="session-name">
                                  {service} : {packagename}{" "}
                                  {type ? `: ${type}` : ""}
                                </p>
                                {activatecancel === 1 &&
                                  (status === 1 ? (
                                    <p
                                      className="other-p"
                                      style={{
                                        color: "#4ec8a3",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        this.props
                                          .cancelPackage({
                                            id,
                                            service,
                                          })
                                          .then((_) => this.getMyReports())
                                      }
                                    >
                                      Cancel
                                    </p>
                                  ) : (
                                    <p className="other-p">
                                      <i>Applied for cancellation</i>
                                    </p>
                                  ))}
                              </div>
                            </Col>
                            <Col sm={6}>
                              <Row className="p-0 m-0">
                                <Col className="p-0">
                                  <div className="text-right">
                                    <p className="number">0{sessionsdone}</p>
                                    <p className="other-p">COMPLETED</p>
                                  </div>
                                </Col>
                                <Col className="p-0">
                                  <div className="text-right">
                                    <p className="number">
                                      0{totalsessions - sessionsdone}
                                    </p>
                                    <p className="other-p">PENDING</p>
                                  </div>
                                </Col>
                                <Col className="p-0">
                                  <div className="text-right">
                                    <p className="number">0{totalsessions}</p>
                                    <p className="other-p">TOTAL</p>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row className="justify-content-between p-0 m-0">
                            <p>Progress</p>
                            <p>{pert}% Completed</p>
                          </Row>
                          <ProgressBar now={pert} />
                          {sessionsdone === totalsessions && (
                            <Row className="p-0 m-0">
                              <button
                                className="ar-button style-flat action-btn col-12"
                                onClick={() => this.handleFB(id, service)}
                              >
                                <span className="button-text">My Summary</span>
                              </button>
                              <button
                                className="ar-button style-flat action-btn col-12 mt-lg-0 mt-3"
                                onClick={() => this.handleGFB(id, service)}
                              >
                                <span className="button-text">
                                  Coaching Summary
                                </span>
                              </button>
                              <span
                                style={{ fontSize: "0.9rem" }}
                                className="py-2"
                              >
                                Approve Coaching Summary to earn 25 Frenz Coins
                              </span>
                            </Row>
                          )}
                        </Card>
                      </div>
                    );
                  }
                )
                : null}
            </Col>
          </Row>
          :
          <p>No Feedback to show</p>
        }
        {this.state.givingFB && (
          <FeedbackModal
            show={this.state.givingFB}
            hide={() => this.setState({ givingFB: false })}
            id={this.state.sesId}
            service={this.state.serviceName}
          />
        )}
        {this.state.viewingFB && (
          <GiversFeedback
            show={this.state.viewingFB}
            id={this.state.sesId}
            service={this.state.serviceName}
            hide={() => this.setState({ viewingFB: false })}
          />
        )}
      </div>
    );
  }
}
const stp = (state) => {
  return {
    seekerstatus: state.user.user.seekerstatus,
    ikigai: state.user.user.ikigai,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getReport: () => dispatch(getReport()),
    getMyReports: () => dispatch(getMyReports()),
    cancelPackage: (data) => dispatch(cancelPackage(data)),
    VisitingUser: (data) => dispatch(VisitingUser(data)),
  };
};

export default connect(stp, mapDispatchToProps)(MyReports);
